import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../common/services/auth.service';
import { StorageService } from '../../common/services/storage.service';
import { CurrentUser } from '../../common/models/user';
import { UserService } from '../../common/services/user.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-sign-in',
    imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent implements OnDestroy {
    private destroy$ = new Subject<void>();

    // isToggled
    isToggled = false;
    authForm: FormGroup;
    
    // Error message property
    errorMessage: string | null = null;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private authService: AuthService,
        private storageService: StorageService,
        private userService: UserService
    ) {
        this.authForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(8)]],
        });
        this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    // Password Hide
    hide = true;

    private routeToDashboard(): void {
        const user = this.storageService.getUser()!;
        if (user.isMunicipalityAdministrator()) {
          this.router.navigate(['municipality/associations']);
        } else if (user.isAssociationResponsiblePerson()) {
          this.router.navigate(['/association/grants']);
        } else if (user.isSystemAdministrator()) {
          this.router.navigate(['/administrator/municipalities']);
        } else {
          this.router.navigate(['/authentication']);
        }
    }

    // Handle form submission
    onSubmit() {
        if (this.authForm.valid) {
            const { email, password } = this.authForm.value;
            this.authService.login(email, password).pipe(takeUntil(this.destroy$)).subscribe({
                next: (auth) => {
                this.storageService.saveAuthData(auth); 
                this.userService.getCurrentUser().pipe(takeUntil(this.destroy$)).subscribe({
                        next: (user: CurrentUser) => {
                            this.storageService.saveUser(user);
                            this.routeToDashboard();
                        },
                        error: () => {
                            this.errorMessage = 'Dogodila se pogreška u sustavu. Molimo Vas kontaktirajte administratora.';
                        }
                    });
                },
                error: () => {
                    this.errorMessage = 'Neuspješna prijava. Pogrešna lozinka ili korisničko ime.';
                }
            });
        } else {
            this.errorMessage = 'Obrazac nije valjan. Molimo provjerite polja.';
        }
    }
}